import { render, staticRenderFns } from "./Light.vue?vue&type=template&id=ce1ecd74&scoped=true&"
import script from "./Light.vue?vue&type=script&lang=js&"
export * from "./Light.vue?vue&type=script&lang=js&"
import style0 from "./Light.vue?vue&type=style&index=0&id=ce1ecd74&lang=scss&scoped=true&"
import style1 from "./Light.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1ecd74",
  null
  
)

export default component.exports